import styled from 'styled-components';

export default styled.ul`
    margin: 20px 0 0 0;
    padding: 0;
    list-style-type: none;
    &:focus {
        outline: none;
    }
`;


// WEBPACK FOOTER //
// ./src/SharedComponents/QuestionList.tsx